import { render, staticRenderFns } from "./vxeGrid.vue?vue&type=template&id=ed6cef56&scoped=true&"
import script from "./vxeGrid.vue?vue&type=script&lang=ts&"
export * from "./vxeGrid.vue?vue&type=script&lang=ts&"
import style0 from "./vxeGrid.vue?vue&type=style&index=0&id=ed6cef56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6cef56",
  null
  
)

export default component.exports